// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edition_container {
  width: 100%;
  height: 100vh;
  background-color: #151018;
  position: relative;
  z-index: 1;
}
.edition_container .edition_header {
  width: 100%;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
  display: flex;
  position: relative;
}
.edition_container .edition_header .ai_on_doc {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  position: absolute;
  background-color: rgb(235, 204, 146);
  top: 0.1rem;
  right: 0.1rem;
  padding: 0.1rem 0.3rem;
  font-size: 0.7rem;
  border-radius: 0.2rem;
}
.edition_container .edition_header .ai_on_doc .spinning {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: detecting 0.5s linear infinite;
}
.edition_container .edition_header .edition_logo {
  width: 15%;
  display: flex;
  align-items: center;
  position: relative;
}
.edition_container .edition_header .edition_logo .org {
  display: block;
  position: absolute;
  color: #e8e5e5;
  font-size: 0.8rem;
  top: -1rem;
  left: 40%;
  transform: translateX(-35%);
}
.edition_container .edition_header .edition_logo img {
  width: 30%;
  margin-left: 30%;
  cursor: pointer;
}
.edition_container .edition_header .edition_logo .back {
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 46.34px;
  height: 46.34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: #FFFFFF;
  background-color: #231B27;
  border: 1px solid #231B27;
  border-radius: 0.4rem;
}
.edition_container .edition_header .edition_logo .back:hover {
  background-color: #2a202e;
  color: rgb(214, 65, 10);
}
.edition_container .edition_header .edition_search {
  width: 54%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10.575px;
}
.edition_container .edition_header .edition_search .input {
  width: 100%;
  height: 46.34px;
  padding: 0.48rem 1rem;
  outline: none;
  background-color: #231B27;
  border-radius: 0.6rem;
  color: #898989;
  font-size: 1.2rem;
}
.edition_container .edition_header .edition_search .input::placeholder {
  color: #898989;
}
.edition_container .edition_header .show_due {
  width: 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.edition_container .edition_header .show_due span,
.edition_container .edition_header .show_due a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  color: #e8e5e5;
  font-size: 1.7rem;
  padding: 0.45rem 1.5rem;
  border: 0.15rem solid #231B27;
  background-color: #231B27;
  border-radius: 0.3rem;
  cursor: pointer;
  text-decoration: none;
}
.edition_container .edition_header .show_due span:hover,
.edition_container .edition_header .show_due a:hover {
  border-color: #2c262f;
}
.edition_container .edition_header .show_due img {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e8e5e5;
  padding: 0.1rem 0.1rem;
  background-color: #231B27;
  border-radius: 0.3rem;
  cursor: pointer;
  text-decoration: none;
}
.edition_container .edition_header .show_due .num_of {
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #bd2969;
  position: absolute;
  top: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: black;
}
.edition_container .edition_header #ai {
  position: relative;
}
.edition_container .edition_header #ai .ai_sublist {
  display: block;
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  position: absolute;
  width: 10rem;
  padding: 0.5rem 0;
  background-color: #1C1620;
  border: 1px solid white;
  z-index: 100;
  bottom: -5.5rem;
  border-radius: 0.3rem;
  transition: 0.2s linear;
}
.edition_container .edition_header #ai .ai_sublist .ai_btn {
  display: block;
  font-size: 0.9rem;
  margin: 0 auto;
  background: transparent;
  text-align: center;
  outline: none;
  border: none;
}
.edition_container .edition_header #ai .ai_sublist .ai_btn:hover {
  text-decoration: underline;
}
.edition_container .edition_header #ai:hover .ai_sublist {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
}
.edition_container .edition_header .show_notif {
  width: 8%;
  display: flex;
  justify-content: flex-end;
  padding-right: 0.5rem;
  align-items: center;
  position: relative;
}
.edition_container .edition_header .show_notif .notif {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #231B27;
  color: #e8e5e5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: 0.1s linear;
}
.edition_container .edition_header .show_notif .notif:hover {
  color: #D91D6F;
  font-size: 1.5rem;
}
.edition_container .edition_header .show_notif .num_of {
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #bd2969;
  position: absolute;
  top: -0.3rem;
  left: 80%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: black;
  font-weight: 700;
}
.edition_container .edition_header .edition_avatar {
  width: 15%;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  padding-left: 0.2rem;
}
.edition_container .edition_header .edition_avatar .avatar {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #bababa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 1.3rem;
  font-weight: 700;
  border: 2px solid black;
  cursor: pointer;
  transition: 0.1s linear;
}
.edition_container .edition_header .edition_avatar .avatar:hover {
  background-color: #e8e5e5;
  color: rgb(214, 65, 10);
  font-size: 1.5rem;
}
.edition_container .edition_header .edition_avatar .sub_list {
  width: 80%;
  margin: 0 auto;
  padding: 1rem 0.2rem;
  background-color: #231B27;
  position: absolute;
  bottom: -6.5rem;
  border: 1px solid #a0a0a0;
  border-radius: 0.6rem;
  z-index: 10;
}
.edition_container .edition_header .edition_avatar .sub_list .item {
  display: block;
  margin: 0.4rem 1rem;
  text-decoration: none;
  color: #FFFFFF;
}
.edition_container .edition_header .edition_avatar .sub_list .item:hover {
  color: rgb(214, 65, 10);
}
.edition_container .edition_header .edition_avatar .notif_list {
  width: 130%;
  height: 50vh;
  margin: 0 auto;
  padding: 1rem 0.6rem;
  background-color: #231B27;
  position: absolute;
  bottom: -50vh;
  left: -90%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 0.6rem;
  z-index: 10;
}
.edition_container .edition_header .edition_avatar .notif_list .nofit_item {
  display: block;
  width: 100%;
  font-size: 0.6rem;
  color: #e8e5e5;
  padding: 0.8rem 0.6rem;
  background-color: #bd2969;
}
.edition_container .edition_content {
  width: 100%;
  height: calc(100vh - 93.19px);
  padding: 0 2rem;
  display: flex;
  position: relative;
  overflow-x: hidden;
}
.edition_container .edition_content .left_section {
  background-color: #231B27;
  width: 10%;
  height: calc(100vh - 93.19px);
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  padding: 1rem 0;
  overflow-y: auto;
}
.edition_container .edition_content .left_section .splitted_img {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0.5rem auto;
  position: relative;
}
.edition_container .edition_content .left_section .splitted_img img {
  width: 60%;
  cursor: pointer;
  transition: 0.2s linear;
}
.edition_container .edition_content .left_section .splitted_img img:hover {
  transform: scale(0.9);
}
.edition_container .edition_content .left_section .splitted_img .pageNum {
  color: #898989;
  position: absolute;
  left: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
}
.edition_container .edition_content .left_section .splitted_img .dot {
  font-size: 0.8rem;
  display: flex;
  border-radius: 50%;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  color: rgb(9, 214, 9);
}
.edition_container .edition_content .left_section .splitted_img .hasComment {
  font-size: 0.8rem;
  display: flex;
  border-radius: 50%;
  position: absolute;
  left: 0.1rem;
  top: 1.1rem;
  color: rgb(214, 122, 9);
}
.edition_container .edition_content .left_section .splitted_img .page_status {
  font-size: 0.8rem;
  display: flex;
  border-radius: 50%;
  position: absolute;
  left: 0.1rem;
  top: 0.2rem;
  color: rgb(255, 255, 255);
}
.edition_container .edition_content .left_section .splitted_img .page_status_img {
  display: flex;
  width: 15px;
  position: absolute;
  left: 0.1rem;
  top: 0.2rem;
}
.edition_container .edition_content .middle_section {
  background-color: #231B27;
  width: 44%;
  height: inherit;
  margin: 0 1%;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
}
.edition_container .edition_content .middle_section_header {
  width: 100%;
  padding: 0.8rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edition_container .edition_content .middle_section_header .ref_name {
  color: #898989;
  font-weight: 400;
  font-size: 1rem;
  width: 50%;
}
.edition_container .edition_content .middle_section_header .btns_block {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.edition_container .edition_content .middle_section_header .btns_block .change {
  border: 1px solid #898989;
  padding: 0.5rem 0.6rem;
  color: #898989;
  font-size: 0.8rem;
  font-weight: 400;
  border-radius: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.edition_container .edition_content .middle_section_header .btns_block .change:hover {
  border-color: orange;
}
.edition_container .edition_content .middle_section_header .btns_block .change .export_list {
  width: 100%;
  padding: 0.5rem 0.8rem;
  background-color: #141015;
  position: absolute;
  left: 0;
  bottom: -5.1rem;
  z-index: 100;
  border-radius: 0.3rem;
}
.edition_container .edition_content .middle_section_header .btns_block .change .export_list ul {
  text-align: left;
}
.edition_container .edition_content .middle_section_header .btns_block .change .export_list ul li {
  margin: 0.5rem auto;
  list-style: none;
  cursor: pointer;
}
.edition_container .edition_content .middle_section_header .btns_block .change .export_list ul li:hover {
  color: #FFFFFF;
  text-decoration: underline;
}
.edition_container .edition_content .middle_section_header .btns_block .showOV {
  border: 1px solid #898989;
  padding: 0.5rem 0.6rem;
  color: #898989;
  font-size: 0.8rem;
  font-weight: 400;
  border-radius: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.edition_container .edition_content .middle_section_header .btns_block .showOV:hover {
  border-color: orange;
}
.edition_container .edition_content .middle_section_main {
  width: 100%;
  height: calc(100vh - 93.19px - 70.59px);
  overflow-x: auto;
  -webkit-user-select: none;
          user-select: none;
}
.edition_container .edition_content .middle_section_main .active_img {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.edition_container .edition_content .middle_section_main .active_img img {
  display: block;
  width: 100%;
}
.edition_container .edition_content .middle_section_main .active_img .spote {
  position: absolute;
  font-size: 50%;
  padding: 0.1rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.edition_container .edition_content .middle_section_main .active_img .spote svg {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.edition_container .edition_content .middle_section_main .active_img .spote svg text {
  text-anchor: middle;
  dominant-baseline: middle;
}
.edition_container .edition_content .middle_section_main .active_img .spote .resizer {
  width: 5px;
  height: 5px;
  background: red;
  position: absolute;
  right: 0px;
  bottom: 0px;
  cursor: se-resize;
}
.edition_container .edition_content .middle_section_main .active_img .spote .rotation {
  width: 8px;
  height: 8px;
  background: red;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  cursor: grab;
}
.edition_container .edition_content .middle_section_main .active_img .spote .delete_zone {
  display: none;
}
.edition_container .edition_content .middle_section_main .active_img .spote .ref_spot {
  display: block;
  position: absolute;
  top: -0.8rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgb(254, 50, 50);
  color: #FFFFFF;
}
.edition_container .edition_content .middle_section_main .active_img .spote:hover .delete_zone {
  display: block;
  color: red;
  font-size: 1rem;
  font-weight: 600;
  position: absolute;
  top: -1.3rem;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.edition_container .edition_content .middle_section_main .active_img .spote:hover .ref_spot {
  display: none;
}
.edition_container .edition_content .middle_section_main .active_img .hold_on {
  width: 100%;
  height: calc(100vh - 93.19px - 70.59px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.edition_container .edition_content .middle_section_main .active_img .hold_on img {
  width: 30%;
  animation: dog 1.5s ease-in-out infinite;
}
.edition_container .edition_content .middle_section_main .active_img .hold_on h3 {
  color: #bababa;
  font-size: 0.8rem;
  font-weight: 600;
}
.edition_container .edition_content .middle_section .hold_on {
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.edition_container .edition_content .middle_section .hold_on img {
  width: 30%;
  animation: dog 1.5s ease-in-out infinite;
}
.edition_container .edition_content .middle_section .hold_on h3 {
  color: #bababa;
  font-size: 0.8rem;
  font-weight: 600;
}
.edition_container .edition_content .right_section {
  background-color: #231B27;
  width: 44%;
  height: inherit;
  margin: 0 1%;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
}
.edition_container .edition_content .right_section_header {
  width: 100%;
  padding: 0.8rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edition_container .edition_content .right_section_header .ref_name {
  color: #898989;
  font-weight: 400;
  font-size: 1rem;
}
.edition_container .edition_content .right_section_header .change {
  border: 1px solid #898989;
  padding: 0.5rem 0.6rem;
  color: #898989;
  font-size: 0.8rem;
  font-weight: 400;
  border-radius: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.edition_container .edition_content .right_section_header .change:hover {
  border-color: orange;
}
.edition_container .edition_content .right_section_header .change .export_list {
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #141015;
  position: absolute;
  left: 0;
  bottom: -3.5rem;
  z-index: 100;
  border-radius: 0.3rem;
}
.edition_container .edition_content .right_section_header .change .export_list li {
  list-style: none;
  cursor: pointer;
}
.edition_container .edition_content .right_section_header .change .export_list li:hover {
  color: #FFFFFF;
  text-decoration: underline;
}
.edition_container .edition_content .right_section_main {
  width: 100%;
  height: calc(100vh - 93.19px - 70.59px);
  overflow-x: auto;
}
.edition_container .edition_content .right_section_main .active_img {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.edition_container .edition_content .right_section_main .active_img img {
  display: block;
  width: 100%;
}
.edition_container .edition_content .right_section_main .active_img .spote {
  position: absolute;
  font-size: 50%;
  padding: 0.1rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.edition_container .edition_content .right_section_main .active_img .spote .ref_spot {
  display: block;
  position: absolute;
  top: -0.8rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgb(254, 50, 50);
  color: #FFFFFF;
}
.edition_container .edition_content_slide {
  display: flex;
  width: 35%;
  height: inherit;
  position: absolute;
  right: calc(2rem - 35%);
  border-top-left-radius: 0.8rem;
  overflow-y: hidden;
  background-color: #231B27;
  border: 1px solid #1C1620;
  transition: 0.3s linear;
}
.edition_container .edition_content_slide .openClose {
  width: 2rem;
  height: inherit;
  background-color: #1C1620;
  color: #979797;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
}
.edition_container .edition_content_slide .openClose span {
  transition: 0.3s linear;
}
.edition_container .edition_content_slide .openClose:hover {
  background-color: #29202f;
}
.edition_container .edition_content_slide .texts_zone {
  width: calc(100% - 2rem);
  height: inherit;
  overflow-y: hidden;
  padding: 1rem 0;
}
.edition_container .edition_content_slide .texts_zone_header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1.2rem;
  color: #979797;
}
.edition_container .edition_content_slide .texts_zone_header h2,
.edition_container .edition_content_slide .texts_zone_header .progress {
  font-size: 1.1rem;
  font-weight: 700;
}
.edition_container .edition_content_slide .texts_zone_header .trans_icon {
  font-size: 1.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.edition_container .edition_content_slide .texts_zone_header .valid_page {
  color: rgb(9, 214, 9);
  font-weight: 700;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content {
  width: 100%;
  height: calc(100vh - 157.19px);
  overflow-y: auto;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start {
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start img {
  width: 34%;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #979797;
  margin-top: 1.8rem;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start p {
  font-size: 0.7rem;
  font-weight: 600;
  width: 68%;
  margin-top: 0.4rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #979797;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start button {
  width: 12.9rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: #FFFFFF;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.6rem 1rem;
  outline: none;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start button:hover {
  background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);
  border: 1px solid #FFFFFF;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start button .img {
  width: 12%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start button .creating {
  display: flex;
  animation: detecting 0.8s linear infinite;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start button .trans_icon {
  display: flex;
  font-size: 1rem;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start .or {
  margin: 1rem 0;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start .validate_page {
  background: rgba(56, 47, 61, 0.6509803922);
  color: #e8e5e5;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.5rem 0.2rem;
  outline: none;
  border-radius: 0.3rem;
  border: 1px solid rgba(255, 255, 255, 0.1490196078);
  cursor: pointer;
}
.edition_container .edition_content_slide .texts_zone .texts_zone_content_start .validate_page:hover {
  background: rgba(72, 60, 79, 0.6509803922);
}
.edition_container .import_popup {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid red;
}
.edition_container .import_popup .pop_up {
  width: 30%;
  padding: 1rem 0.6rem;
  background-color: #231B27;
  border: 2px solid #1C1620;
}
.edition_container .import_popup .pop_up h4 {
  color: #979797;
  font-size: 0.8rem;
  font-weight: 500;
}
.edition_container .import_popup .pop_up .btns_block {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.edition_container .import_popup .pop_up .btns_block button {
  width: 30%;
  cursor: pointer;
  padding: 0.5rem 0.3rem;
  border-radius: 0.3rem;
  outline: none;
  border: none;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: #FFFFFF;
  font-weight: 700;
}
.edition_container .import_popup .pop_up .btns_block .upload {
  background-color: rgb(88, 240, 18);
}
.edition_container .import_popup .pop_up .btns_block .cancel {
  background-color: rgb(253, 110, 110);
}
.edition_container .import_popup .pop_up .importing {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1rem;
  color: #979797;
  font-weight: 600;
  text-align: center;
  margin: 0.2rem auto;
  animation: detecting 0.8s linear infinite;
}

.expoer_pdf_section {
  width: 100%;
  height: 100vh;
  padding: 1rem 2rem;
  position: absolute;
  top: 0;
  background-color: #151018;
  z-index: 2;
  overflow: hidden;
}
.expoer_pdf_section .expoer_pdf_section_btns {
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
}
.expoer_pdf_section .expoer_pdf_section_btns .export_progress {
  color: #bababa;
  font-size: 0.8rem;
  font-weight: 500;
}
.expoer_pdf_section .expoer_pdf_section_btns button {
  border: 1px solid #898989;
  padding: 0.5rem 1rem;
  background-color: #231B27;
  color: #898989;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 0.4rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.expoer_pdf_section .expoer_pdf_section_btns button:hover {
  border-color: orange;
  color: orange;
}
.expoer_pdf_section .expoer_pdf_section_btns button .creating {
  display: flex;
  animation: detecting 0.5s linear infinite;
}
.expoer_pdf_section .expoer_pdf_section_main {
  width: 100%;
  height: calc(100vh - 6rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  overflow: auto;
  padding: 0.5rem 0;
  border: 1px solid #898989;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  position: relative;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .spote {
  position: absolute;
  font-size: 50%;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .spote svg {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .spote svg text {
  text-anchor: middle;
  dominant-baseline: middle;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .hold_on {
  width: 20rem;
  height: calc(100vh - 93.19px - 70.59px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .hold_on img {
  width: 50%;
  animation: dog 1.5s ease-in-out infinite;
}
.expoer_pdf_section .expoer_pdf_section_main .active_img_export .hold_on h3 {
  color: #bababa;
  font-size: 0.8rem;
  font-weight: 600;
}
.expoer_pdf_section .expoer_pdf_section_main .export_pdf_waiting {
  color: #e8e5e5;
  width: 100%;
  height: calc(100vh - 6rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.expoer_pdf_section .expoer_pdf_section_main .export_pdf_waiting progress::-moz-progress-bar {
  display: block;
  width: 15%;
  height: 0.5rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
}
.expoer_pdf_section .expoer_pdf_section_main .export_pdf_waiting progress::-webkit-progress-value {
  display: block;
  width: 15%;
  height: 0.5rem;
  background: #92124A;
}
.expoer_pdf_section .expoer_pdf_section_main .export_pdf_waiting p {
  font-size: 0.8rem;
  font-weight: 600;
  color: #bababa;
}
.expoer_pdf_section .expoer_pdf_section_main .export_pdf_waiting progress {
  display: block;
  width: 15%;
  height: 0.5rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
}

@keyframes dog {
  0% {
    transform: rotate(-18deg);
  }
  50% {
    transform: rotate(18deg);
  }
  100% {
    transform: rotate(-18deg);
  }
}
@keyframes detecting {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/edition/_Edition.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AACJ;AACI;EACI,WAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;AACR;AACQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AACZ;AACY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;AAChB;AAGQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADZ;AAGY;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AADhB;AAIY;EACI,UAAA;EACA,gBAAA;EACA,eAAA;AAFhB;AAKY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAHhB;AAKgB;EACI,yBAAA;EACA,uBAAA;AAHpB;AAQQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,uBAAA;AAPZ;AASY;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AAPhB;AASgB;EACI,cAAA;AAPpB;AAYQ;EACI,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAVZ;AAaY;;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAXhB;AAagB;;EACI,qBAAA;AAVpB;AAcY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EAEA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAbhB;AAgBY;EACI,cAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAdhB;AAkBQ;EACI,kBAAA;AAhBZ;AAkBY;EACI,cAAA;EACA,4CAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;AAhBhB;AAkBgB;EACI,cAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAhBpB;AAkBoB;EACI,0BAAA;AAhBxB;AAqBY;EACI,kDAAA;AAnBhB;AAuBQ;EACI,SAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AArBZ;AAwBY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EAEA,uBAAA;AAvBhB;AAyBgB;EACI,cAAA;EAEA,iBAAA;AAxBpB;AA4BY;EACI,cAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AA1BhB;AA8BQ;EACI,UAAA;EAIA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AA/BZ;AAkCY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AAhChB;AAkCgB;EACI,yBAAA;EACA,uBAAA;EACA,iBAAA;AAhCpB;AAoCY;EACI,UAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EAGA,qBAAA;EACA,WAAA;AApChB;AAsCgB;EACI,cAAA;EAEA,mBAAA;EACA,qBAAA;EACA,cAAA;AArCpB;AAuCoB;EACI,uBAAA;AArCxB;AA0CY;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,WAAA;AAzChB;AA2CgB;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;AAzCpB;AA+CI;EACI,WAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AA7CR;AAgDQ;EACI,yBAAA;EACA,UAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AA9CZ;AAgDY;EACI,UAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA/ChB;AAkDgB;EACI,UAAA;EACA,eAAA;EACA,uBAAA;AAhDpB;AAkDoB;EACI,qBAAA;AAhDxB;AAoDgB;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AAlDpB;AAqDgB;EAII,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AAtDpB;AAyDgB;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AAvDpB;AA0DgB;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAxDpB;AA2DgB;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAzDpB;AA8DQ;EACI,yBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;AA5DZ;AA+DY;EACI,WAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA7DhB;AA+DgB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AA7DpB;AAiEgB;EACI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AA/DpB;AAiEoB;EACI,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA/DxB;AAiEwB;EACI,oBAAA;AA/D5B;AAkEwB;EACI,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AAhE5B;AAkE4B;EACI,gBAAA;AAhEhC;AAkEgC;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;AAhEpC;AAkEoC;EACI,cAAA;EACA,0BAAA;AAhExC;AAuEoB;EACI,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AArExB;AAuEwB;EACI,oBAAA;AArE5B;AA2EY;EACI,WAAA;EACA,uCAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAzEhB;AA2EgB;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AAzEpB;AA4EoB;EACI,cAAA;EACA,WAAA;AA1ExB;AA6EoB;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA5ExB;AA8EwB;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AA5E5B;AA+E4B;EAEI,mBAAA;EACA,yBAAA;AA9EhC;AAkFwB;EACI,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AAhF5B;AAmFwB;EACI,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAjF5B;AA4HwB;EACI,aAAA;AA1H5B;AA6HwB;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kCAAA;EACA,cAAA;AA3H5B;AA8HwB;EACI,cAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AA5H5B;AA+HwB;EACI,aAAA;AA7H5B;AAiIoB;EACI,WAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA/HxB;AAkIwB;EACI,UAAA;EACA,wCAAA;AAhI5B;AAmIwB;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAjI5B;AAuIY;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AArIhB;AAuIgB;EACI,UAAA;EACA,wCAAA;AArIpB;AAwIgB;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAtIpB;AA4IQ;EACI,yBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;AA1IZ;AA4IY;EACI,WAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1IhB;AA6IgB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AA3IpB;AA8IgB;EACI,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA5IpB;AA8IoB;EACI,oBAAA;AA5IxB;AA+IoB;EACI,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AA7IxB;AA+IwB;EACI,gBAAA;EACA,eAAA;AA7I5B;AA+I4B;EACI,cAAA;EACA,0BAAA;AA7IhC;AAqJY;EACI,WAAA;EACA,uCAAA;EACA,gBAAA;AAnJhB;AAqJgB;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AAnJpB;AAsJoB;EACI,cAAA;EACA,WAAA;AApJxB;AAuJoB;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtJxB;AAwJwB;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kCAAA;EACA,cAAA;AAtJ5B;AA6JQ;EACI,aAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;AA3JZ;AA6JY;EACI,WAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AA3JhB;AA6JgB;EACI,uBAAA;AA3JpB;AA8JgB;EACI,yBAAA;AA5JpB;AAgKY;EACI,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AA9JhB;AAgKgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;AA9JpB;AAgKoB;;EAEI,iBAAA;EACA,gBAAA;AA9JxB;AAiKoB;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/JxB;AAkKoB;EACI,qBAAA;EACA,gBAAA;AAhKxB;AAoKgB;EACI,WAAA;EACA,8BAAA;EACA,gBAAA;AAlKpB;AAoKoB;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAlKxB;AAoKwB;EACI,UAAA;AAlK5B;AAqKwB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAnK5B;AAsKwB;EACI,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AApK5B;AAuKwB;EACI,cAAA;EACA,6DAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AArK5B;AAuK4B;EACI,8DAAA;EACA,yBAAA;AArKhC;AAwK4B;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtKhC;AAyK4B;EACI,aAAA;EACA,yCAAA;AAvKhC;AA0K4B;EACI,aAAA;EACA,eAAA;AAxKhC;AA4KwB;EACI,cAAA;AA1K5B;AA6KwB;EACI,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EAIA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mDAAA;EACA,eAAA;AA9K5B;AAkL4B;EACI,0CAAA;AAhLhC;AAwMI;EACI,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAtMR;AAwMQ;EACI,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;AAtMZ;AAwMY;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAtMhB;AAyMY;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AAvMhB;AAyMgB;EACI,UAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,6DAAA;EACA,cAAA;EACA,gBAAA;AAvMpB;AA0MgB;EACI,kCAAA;AAxMpB;AA2MgB;EACI,oCAAA;AAzMpB;AA6MY;EACI,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AA3MhB;;AAkNA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;AA/MJ;AAiNI;EACI,iBAAA;EACA,aAAA;EACA,8BAAA;AA/MR;AAiNQ;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AA/MZ;AAkNQ;EACI,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AAhNZ;AAkNY;EACI,oBAAA;EACA,aAAA;AAhNhB;AAmNY;EACI,aAAA;EACA,yCAAA;AAjNhB;AAsNI;EACI,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;AApNR;AAsNQ;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;AApNZ;AAuNY;EACI,kBAAA;EACA,cAAA;EAEA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtNhB;AA0NgB;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAxNpB;AA0NoB;EAEI,mBAAA;EACA,yBAAA;AAzNxB;AA8NY;EACI,YAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA5NhB;AA+NgB;EACI,UAAA;EACA,wCAAA;AA7NpB;AAgOgB;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AA9NpB;AAoOQ;EACI,cAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAlOZ;AAoOY;EACI,cAAA;EACA,UAAA;EACA,cAAA;EACA,6DAAA;AAlOhB;AAqOY;EACI,cAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;AAnOhB;AAsOY;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AApOhB;AAuOY;EACI,cAAA;EACA,UAAA;EACA,cAAA;EACA,6DAAA;AArOhB;;AA2OA;EACI;IACI,yBAAA;EAxON;EA2OE;IACI,wBAAA;EAzON;EA4OE;IACI,yBAAA;EA1ON;AACF;AA6OA;EACI;IACI,uBAAA;EA3ON;EA8OE;IACI,yBAAA;EA5ON;AACF","sourcesContent":[".edition_container {\n    width: 100%;\n    height: 100vh;\n    background-color: #151018;\n    position: relative;\n    z-index: 1;\n\n    .edition_header {\n        width: 100%;\n        padding: 2rem 1.5rem .2rem 1.5rem;\n        display: flex;\n        position: relative;\n\n        .ai_on_doc {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: .3rem;\n            position: absolute;\n            background-color: rgb(235, 204, 146);\n            top: .1rem;\n            right: .1rem;\n            padding: .1rem .3rem;\n            font-size: .7rem;\n            border-radius: .2rem;\n\n            .spinning {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                animation: detecting .5s linear infinite;\n            }\n        }\n\n        .edition_logo {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            .org {\n                display: block;\n                position: absolute;\n                color: #e8e5e5;\n                font-size: .8rem;\n                top: -1rem;\n                left: 40%;\n                transform: translateX(-35%);\n            }\n\n            img {\n                width: 30%;\n                margin-left: 30%;\n                cursor: pointer;\n            }\n\n            .back {\n                position: absolute;\n                right: .4rem;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 46.34px;\n                height: 46.34px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                color: #FFFFFF;\n                background-color: #231B27;\n                border: 1px solid #231B27;\n                border-radius: .4rem;\n\n                &:hover {\n                    background-color: #2a202e;\n                    color: rgb(214, 65, 10);\n                }\n            }\n        }\n\n        .edition_search {\n            width: 54%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            // border: 1px solid red;\n            padding-right: 10.575px;\n\n            .input {\n                width: 100%;\n                height: 46.34px;\n                padding: .48rem 1rem;\n                outline: none;\n                background-color: #231B27;\n                border-radius: .6rem;\n                color: #898989;\n                font-size: 1.2rem;\n\n                &::placeholder {\n                    color: #898989;\n                }\n            }\n        }\n\n        .show_due {\n            width: 7%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            // border: 1px solid red;\n\n            span,\n            a {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 90%;\n                color: #e8e5e5;\n                font-size: 1.7rem;\n                padding: .45rem 1.5rem;\n                border: .15rem solid #231B27;\n                background-color: #231B27;\n                border-radius: .3rem;\n                cursor: pointer;\n                text-decoration: none;\n\n                &:hover {\n                    border-color: #2c262f;\n                }\n            }\n\n            img {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                color: #e8e5e5;\n                padding: .1rem .1rem;\n                // border: 1px solid #e8e5e5;\n                background-color: #231B27;\n                border-radius: .3rem;\n                cursor: pointer;\n                text-decoration: none;\n            }\n\n            .num_of {\n                display: block;\n                width: 1.2rem;\n                height: 1.2rem;\n                border-radius: 50%;\n                background-color: #bd2969;\n                position: absolute;\n                top: -.5rem;\n                left: 50%;\n                transform: translateX(-50%);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: .8rem;\n                color: black;\n            }\n        }\n\n        #ai {\n            position: relative;\n\n            .ai_sublist {\n                display: block;\n                clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n                position: absolute;\n                width: 10rem;\n                padding: .5rem 0;\n                background-color: #1C1620;\n                border: 1px solid white;\n                z-index: 100;\n                bottom: -5.5rem;\n                border-radius: .3rem;\n                transition: .2s linear;\n\n                .ai_btn {\n                    display: block;\n                    font-size: .9rem;\n                    margin: 0 auto;\n                    background: transparent;\n                    text-align: center;\n                    outline: none;\n                    border: none;\n\n                    &:hover {\n                        text-decoration: underline;\n                    }\n                }\n            }\n\n            &:hover .ai_sublist {\n                clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n            }\n        }\n\n        .show_notif {\n            width: 8%;\n            display: flex;\n            justify-content: flex-end;\n            padding-right: .5rem;\n            align-items: center;\n            position: relative;\n            // border: 1px solid red;\n\n            .notif {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #231B27;\n                color: #e8e5e5;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                // position: relative;\n                transition: .1s linear;\n\n                &:hover {\n                    color: #D91D6F;\n                    // color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n            }\n\n            .num_of {\n                display: block;\n                width: 1.2rem;\n                height: 1.2rem;\n                border-radius: 50%;\n                background-color: #bd2969;\n                position: absolute;\n                top: -.3rem;\n                left: 80%;\n                transform: translateX(-50%);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: .8rem;\n                color: black;\n                font-weight: 700;\n            }\n        }\n\n        .edition_avatar {\n            width: 15%;\n            // display: flex;\n            // justify-content: center;\n            // align-items: center;\n            position: relative;\n            user-select: none;\n            padding-left: .2rem;\n            // border: 1px solid green;\n\n            .avatar {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #bababa;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                position: absolute;\n                font-size: 1.3rem;\n                font-weight: 700;\n                border: 2px solid black;\n                cursor: pointer;\n                transition: .1s linear;\n\n                &:hover {\n                    background-color: #e8e5e5;\n                    color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n            }\n\n            .sub_list {\n                width: 80%;\n                margin: 0 auto;\n                padding: 1rem .2rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -6.5rem;\n                border: 1px solid #a0a0a0;\n                ;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .item {\n                    display: block;\n                    // text-align: center;\n                    margin: .4rem 1rem;\n                    text-decoration: none;\n                    color: #FFFFFF;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                    }\n                }\n            }\n\n            .notif_list {\n                width: 130%;\n                height: 50vh;\n                margin: 0 auto;\n                padding: 1rem .6rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -50vh;\n                left: -90%;\n                display: flex;\n                flex-direction: column;\n                gap: .2rem;\n                overflow-x: hidden;\n                overflow-y: auto;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .nofit_item {\n                    display: block;\n                    width: 100%;\n                    font-size: .6rem;\n                    color: #e8e5e5;\n                    padding: .8rem .6rem;\n                    background-color: #bd2969;\n                }\n            }\n        }\n    }\n\n    .edition_content {\n        width: 100%;\n        height: calc(100vh - 93.19px);\n        padding: 0 2rem;\n        display: flex;\n        position: relative;\n        overflow-x: hidden;\n        // border: 1px solid red;\n\n        .left_section {\n            background-color: #231B27;\n            width: 10%;\n            height: calc(100vh - 93.19px);\n            border-top-left-radius: .8rem;\n            border-top-right-radius: .8rem;\n            padding: 1rem 0;\n            overflow-y: auto;\n\n            .splitted_img {\n                width: 90%;\n                // height: 6.5rem;\n                display: flex;\n                justify-content: flex-end;\n                align-items: center;\n                margin: .5rem auto;\n                position: relative;\n                // background-color: #88878729;\n\n                img {\n                    width: 60%;\n                    cursor: pointer;\n                    transition: .2s linear;\n\n                    &:hover {\n                        transform: scale(.9);\n                    }\n                }\n\n                .pageNum {\n                    color: #898989;\n                    position: absolute;\n                    left: .2rem;\n                    top: 50%;\n                    transform: translateY(-50%);\n                }\n\n                .dot {\n                    // width: .5rem;\n                    // height: .5rem;\n                    // background-color: green;\n                    font-size: .8rem;\n                    display: flex;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: .1rem;\n                    top: .1rem;\n                    color: rgb(9, 214, 9);\n                }\n\n                .hasComment {\n                    font-size: .8rem;\n                    display: flex;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: .1rem;\n                    top: 1.1rem;\n                    color: rgb(214, 122, 9);\n                }\n\n                .page_status {\n                    font-size: .8rem;\n                    display: flex;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: .1rem;\n                    top: .2rem;\n                    color: rgb(255, 255, 255);\n                }\n\n                .page_status_img {\n                    display: flex;\n                    width: 15px;\n                    position: absolute;\n                    left: .1rem;\n                    top: .2rem;\n                }\n            }\n        }\n\n        .middle_section {\n            background-color: #231B27;\n            width: 44%;\n            height: inherit;\n            margin: 0 1%;\n            border-top-left-radius: .8rem;\n            border-top-right-radius: .8rem;\n            // overflow: auto;\n\n            &_header {\n                width: 100%;\n                padding: .8rem 1rem;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                .ref_name {\n                    color: #898989;\n                    font-weight: 400;\n                    font-size: 1rem;\n                    width: 50%;\n                    // filter: drop-shadow(0 0 4px rgb(206, 0, 0));\n                }\n\n                .btns_block {\n                    width: 50%;\n                    display: flex;\n                    justify-content: flex-end;\n                    gap: 1rem;\n\n                    .change {\n                        border: 1px solid #898989;\n                        padding: .5rem .6rem;\n                        color: #898989;\n                        font-size: .8rem;\n                        font-weight: 400;\n                        border-radius: .4rem;\n                        display: flex;\n                        justify-content: space-between;\n                        align-items: center;\n                        position: relative;\n                        cursor: pointer;\n\n                        &:hover {\n                            border-color: orange;\n                        }\n\n                        .export_list {\n                            width: 100%;\n                            padding: .5rem .8rem;\n                            background-color: #141015;\n                            position: absolute;\n                            left: 0;\n                            bottom: -5.1rem;\n                            z-index: 100;\n                            border-radius: .3rem;\n\n                            ul {\n                                text-align: left;\n\n                                li {\n                                    margin: .5rem auto;\n                                    list-style: none;\n                                    cursor: pointer;\n\n                                    &:hover {\n                                        color: #FFFFFF;\n                                        text-decoration: underline;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    .showOV {\n                        border: 1px solid #898989;\n                        padding: .5rem .6rem;\n                        color: #898989;\n                        font-size: .8rem;\n                        font-weight: 400;\n                        border-radius: .4rem;\n                        display: flex;\n                        justify-content: space-between;\n                        align-items: center;\n                        position: relative;\n                        cursor: pointer;\n\n                        &:hover {\n                            border-color: orange;\n                        }\n                    }\n                }\n            }\n\n            &_main {\n                width: 100%;\n                height: calc((100vh - 93.19px) - 70.59px);\n                overflow-x: auto;\n                user-select: none;\n\n                .active_img {\n                    width: 80%;\n                    margin: 0 auto;\n                    position: relative;\n                    // border: 2px solid green;\n\n                    img {\n                        display: block;\n                        width: 100%;\n                    }\n\n                    .spote {\n                        position: absolute;\n                        font-size: 50%;\n                        padding: .1rem;\n                        font-weight: 500;\n                        display: flex;\n                        // flex-wrap: wrap;\n                        justify-content: center;\n                        align-items: center;\n                        text-align: center;\n\n                        svg {\n                            width: 100%;\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                            overflow-wrap: break-word;\n                            white-space: pre-wrap;\n                            // border: 1px solid orangered;\n\n                            text {\n                                // font-family: sans-serif;\n                                text-anchor: middle;\n                                dominant-baseline: middle;\n                            }\n                        }\n\n                        .resizer {\n                            width: 5px;\n                            height: 5px;\n                            background: red;\n                            position: absolute;\n                            right: 0px;\n                            bottom: 0px;\n                            cursor: se-resize;\n                        }\n\n                        .rotation {\n                            width: 8px;\n                            height: 8px;\n                            background: red;\n                            position: absolute;\n                            bottom: -15px;\n                            left: 50%;\n                            transform: translateX(-50%);\n                            border-radius: 50%;\n                            cursor: grab;\n                        }\n\n                        // pre {\n                        //     // min-width: 100%;\n                        //     // min-height: inherit;\n                        //     display: flex;\n                        //     justify-content: center;\n                        //     align-items: center;\n                        //     padding: .1rem;\n                        //     // font-size: 8px;\n                        //     overflow-wrap: break-word;\n                        //     white-space: pre-wrap;\n                        //     // text-shadow:\n                        //     //     0 0 2px rgba(0, 0, 0, 0.974),\n                        //     //     0 0 5px rgba(0, 0, 0, 0.915),\n                        //     //     0 0 8px rgba(0, 0, 0, 0.72),\n                        //     //     0 0 10px rgba(0, 0, 0, 0.502);\n                        //     // border: 1px solid green;\n\n                        //     .resizer {\n                        //         width: 5px;\n                        //         height: 5px;\n                        //         background: red;\n                        //         position: absolute;\n                        //         right: 0px;\n                        //         bottom: 0px;\n                        //         cursor: se-resize;\n                        //     }\n\n                        //     .rotation {\n                        //         width: 8px;\n                        //         height: 8px;\n                        //         background: red;\n                        //         position: absolute;\n                        //         bottom: -15px;\n                        //         left: 50%;\n                        //         transform: translateX(-50%);\n                        //         border-radius: 50%;\n                        //         cursor: grab;\n                        //     }\n                        // }\n\n                        .delete_zone {\n                            display: none;\n                        }\n\n                        .ref_spot {\n                            display: block;\n                            position: absolute;\n                            top: -.8rem;\n                            width: fit-content;\n                            background-color: rgb(254, 50, 50);\n                            color: #FFFFFF;\n                        }\n\n                        &:hover .delete_zone {\n                            display: block;\n                            color: red;\n                            font-size: 1rem;\n                            font-weight: 600;\n                            position: absolute;\n                            top: -1.3rem;\n                            left: 50%;\n                            transform: translateX(-50%);\n                            cursor: pointer;\n                        }\n\n                        &:hover .ref_spot {\n                            display: none;\n                        }\n                    }\n\n                    .hold_on {\n                        width: 100%;\n                        height: calc((100vh - 93.19px) - 70.59px);\n                        display: flex;\n                        flex-direction: column;\n                        justify-content: center;\n                        align-items: center;\n                        // border: 1px solid red;\n\n                        img {\n                            width: 30%;\n                            animation: dog 1.5s ease-in-out infinite;\n                        }\n\n                        h3 {\n                            color: #bababa;\n                            font-size: .8rem;\n                            font-weight: 600;\n                        }\n                    }\n                }\n            }\n\n            .hold_on {\n                width: 100%;\n                height: inherit;\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n\n                img {\n                    width: 30%;\n                    animation: dog 1.5s ease-in-out infinite;\n                }\n\n                h3 {\n                    color: #bababa;\n                    font-size: .8rem;\n                    font-weight: 600;\n                }\n            }\n\n        }\n\n        .right_section {\n            background-color: #231B27;\n            width: 44%;\n            height: inherit;\n            margin: 0 1%;\n            border-top-left-radius: .8rem;\n            border-top-right-radius: .8rem;\n\n            &_header {\n                width: 100%;\n                padding: .8rem 1rem;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                // border: 1px solid red;\n\n                .ref_name {\n                    color: #898989;\n                    font-weight: 400;\n                    font-size: 1rem;\n                }\n\n                .change {\n                    border: 1px solid #898989;\n                    padding: .5rem .6rem;\n                    color: #898989;\n                    font-size: .8rem;\n                    font-weight: 400;\n                    border-radius: .4rem;\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n                    position: relative;\n                    cursor: pointer;\n\n                    &:hover {\n                        border-color: orange;\n                    }\n\n                    .export_list {\n                        width: 100%;\n                        padding: .5rem 1rem;\n                        background-color: #141015;\n                        position: absolute;\n                        left: 0;\n                        bottom: -3.5rem;\n                        z-index: 100;\n                        border-radius: .3rem;\n\n                        li {\n                            list-style: none;\n                            cursor: pointer;\n\n                            &:hover {\n                                color: #FFFFFF;\n                                text-decoration: underline;\n                            }\n                        }\n                    }\n                }\n\n            }\n\n            &_main {\n                width: 100%;\n                height: calc((100vh - 93.19px) - 70.59px);\n                overflow-x: auto;\n\n                .active_img {\n                    width: 80%;\n                    margin: 0 auto;\n                    position: relative;\n                    // border: 1px solid green;\n\n                    img {\n                        display: block;\n                        width: 100%;\n                    }\n\n                    .spote {\n                        position: absolute;\n                        font-size: 50%;\n                        padding: .1rem;\n                        font-weight: 500;\n                        display: flex;\n                        // flex-wrap: wrap;\n                        justify-content: center;\n                        align-items: center;\n                        text-align: center;\n\n                        .ref_spot {\n                            display: block;\n                            position: absolute;\n                            top: -.8rem;\n                            width: fit-content;\n                            background-color: rgb(254, 50, 50);\n                            color: #FFFFFF;\n                        }\n                    }\n                }\n            }\n        }\n\n        &_slide {\n            display: flex;\n            width: 35%;\n            height: inherit;\n            position: absolute;\n            right: calc(2rem - 35%);\n            border-top-left-radius: .8rem;\n            overflow-y: hidden;\n            background-color: #231B27;\n            border: 1px solid #1C1620;\n            transition: .3s linear;\n\n            .openClose {\n                width: 2rem;\n                height: inherit;\n                background-color: #1C1620;\n                color: #979797;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.2rem;\n                font-weight: 700;\n                cursor: pointer;\n\n                span {\n                    transition: .3s linear;\n                }\n\n                &:hover {\n                    background-color: #29202f;\n                }\n            }\n\n            .texts_zone {\n                width: calc(100% - 2rem);\n                height: inherit;\n                overflow-y: hidden;\n                padding: 1rem 0;\n\n                &_header {\n                    display: flex;\n                    align-items: center;\n                    gap: 1rem;\n                    padding: .5rem 1.2rem;\n                    color: #979797;\n\n                    h2,\n                    .progress {\n                        font-size: 1.1rem;\n                        font-weight: 700;\n                    }\n\n                    .trans_icon {\n                        font-size: 1.3rem;\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                    }\n\n                    .valid_page {\n                        color: rgb(9, 214, 9);\n                        font-weight: 700;\n                    }\n                }\n\n                .texts_zone_content {\n                    width: 100%;\n                    height: calc(100vh - 157.19px);\n                    overflow-y: auto;\n\n                    &_start {\n                        height: inherit;\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        flex-direction: column;\n                        position: relative;\n\n                        img {\n                            width: 34%;\n                        }\n\n                        h3 {\n                            font-size: 1rem;\n                            font-weight: 700;\n                            color: #979797;\n                            margin-top: 1.8rem;\n                        }\n\n                        p {\n                            font-size: .7rem;\n                            font-weight: 600;\n                            width: 68%;\n                            margin-top: .4rem;\n                            margin-bottom: 2rem;\n                            text-align: center;\n                            color: #979797;\n                        }\n\n                        button {\n                            width: 12.9rem;\n                            background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                            color: #FFFFFF;\n                            font-weight: 600;\n                            font-size: .9rem;\n                            display: flex;\n                            justify-content: space-around;\n                            align-items: center;\n                            padding: .6rem 1rem;\n                            outline: none;\n                            border: 1px solid transparent;\n                            border-radius: .3rem;\n                            cursor: pointer;\n                            transition: .2s linear;\n\n                            &:hover {\n                                background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);\n                                border: 1px solid #FFFFFF;\n                            }\n\n                            .img {\n                                width: 12%;\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                            }\n\n                            .creating {\n                                display: flex;\n                                animation: detecting .8s linear infinite;\n                            }\n\n                            .trans_icon {\n                                display: flex;\n                                font-size: 1rem;\n                            }\n                        }\n\n                        .or {\n                            margin: 1rem 0;\n                        }\n\n                        .validate_page {\n                            background: #382F3DA6;\n                            color: #e8e5e5;\n                            font-weight: 700;\n                            font-size: 1rem;\n                            // display: flex;\n                            // align-items: center;\n                            // gap: .5rem;\n                            padding: .5rem .2rem;\n                            outline: none;\n                            border-radius: .3rem;\n                            border: 1px solid #FFFFFF26;\n                            cursor: pointer;\n                            // position: absolute;\n                            // bottom: 0;\n\n                            &:hover {\n                                background: #483c4fa6;\n                            }\n\n                        }\n                    }\n\n                    // .validate_page {\n                    //     display: block;\n                    //     width: 50%;\n                    //     margin: .5rem auto;\n                    //     cursor: pointer;\n                    //     padding: .5rem 0;\n                    //     border-radius: .3rem;\n                    //     background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    //     outline: none;\n                    //     border: 1px solid #FFFFFF26;\n                    //     font-size: 1rem;\n                    //     color: #e8e5e5;\n                    // }\n                }\n            }\n        }\n    }\n\n    .import_popup {\n        position: absolute;\n        top: 0;\n        width: 100vw;\n        height: 100vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid red;\n\n        .pop_up {\n            width: 30%;\n            padding: 1rem .6rem;\n            background-color: #231B27;\n            border: 2px solid #1C1620;\n\n            h4 {\n                color: #979797;\n                font-size: .8rem;\n                font-weight: 500;\n            }\n\n            .btns_block {\n                margin-top: 1rem;\n                width: 100%;\n                display: flex;\n                justify-content: space-around;\n\n                button {\n                    width: 30%;\n                    cursor: pointer;\n                    padding: .5rem .3rem;\n                    border-radius: .3rem;\n                    outline: none;\n                    border: none;\n                    background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    color: #FFFFFF;\n                    font-weight: 700;\n                }\n\n                .upload {\n                    background-color: rgb(88, 240, 18);\n                }\n\n                .cancel {\n                    background-color: rgb(253, 110, 110);\n                }\n            }\n\n            .importing {\n                display: flex;\n                width: fit-content;\n                font-size: 1rem;\n                color: #979797;\n                font-weight: 600;\n                text-align: center;\n                margin: .2rem auto;\n                animation: detecting .8s linear infinite;\n                // border: 1px solid red;\n            }\n        }\n    }\n}\n\n.expoer_pdf_section {\n    width: 100%;\n    height: 100vh;\n    padding: 1rem 2rem;\n    position: absolute;\n    top: 0;\n    background-color: #151018;\n    z-index: 2;\n    overflow: hidden;\n\n    .expoer_pdf_section_btns {\n        padding: .5rem 0;\n        display: flex;\n        justify-content: space-between;\n\n        .export_progress {\n            color: #bababa;\n            font-size: .8rem;\n            font-weight: 500;\n        }\n\n        button {\n            border: 1px solid #898989;\n            padding: .5rem 1rem;\n            background-color: #231B27;\n            color: #898989;\n            font-size: .8rem;\n            font-weight: 600;\n            border-radius: .4rem;\n            cursor: pointer;\n            transition: .2s linear;\n\n            &:hover {\n                border-color: orange;\n                color: orange;\n            }\n\n            .creating {\n                display: flex;\n                animation: detecting .5s linear infinite;\n            }\n        }\n    }\n\n    .expoer_pdf_section_main {\n        width: 100%;\n        height: calc(100vh - 6rem);\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        align-items: center;\n        overflow: auto;\n        padding: .5rem 0;\n        border: 1px solid #898989;\n\n        .active_img_export {\n            width: fit-content;\n            height: fit-content;\n            position: relative;\n            // border: 2px solid black;\n\n            .spote {\n                position: absolute;\n                font-size: 50%;\n                // padding: .1rem;\n                font-weight: 500;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                text-align: center;\n                // overflow-x: hidden;\n                // overflow-y: hidden;\n\n                svg {\n                    width: 100%;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    overflow-wrap: break-word;\n                    white-space: pre-wrap;\n\n                    text {\n                        // font-family: sans-serif;\n                        text-anchor: middle;\n                        dominant-baseline: middle;\n                    }\n                }\n            }\n\n            .hold_on {\n                width: 20rem;\n                height: calc((100vh - 93.19px) - 70.59px);\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n                // border: 1px solid red;\n\n                img {\n                    width: 50%;\n                    animation: dog 1.5s ease-in-out infinite;\n                }\n\n                h3 {\n                    color: #bababa;\n                    font-size: .8rem;\n                    font-weight: 600;\n                }\n            }\n\n        }\n\n        .export_pdf_waiting {\n            color: #e8e5e5;\n            width: 100%;\n            height: calc(100vh - 6rem);\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n\n            progress::-moz-progress-bar {\n                display: block;\n                width: 15%;\n                height: .5rem;\n                background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n            }\n\n            progress::-webkit-progress-value {\n                display: block;\n                width: 15%;\n                height: .5rem;\n                background: #92124A;\n            }\n\n            p {\n                font-size: .8rem;\n                font-weight: 600;\n                color: #bababa;\n            }\n\n            progress {\n                display: block;\n                width: 15%;\n                height: .5rem;\n                background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n            }\n        }\n    }\n}\n\n@keyframes dog {\n    0% {\n        transform: rotate(-18deg);\n    }\n\n    50% {\n        transform: rotate(18deg);\n    }\n\n    100% {\n        transform: rotate(-18deg);\n    }\n}\n\n@keyframes detecting {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
